import { NUMBER } from '@constants/common/number';
import { LAST_DAY_OF_YEAR, TXN_TYPES } from '@constants/enrollmentList/enrollmentList.constant';
import { z } from 'zod';

// Define the Zod schema for enrollment
export const addOrChangeTxnFormSchema = isEdit =>
    z
        .object({
            enrollmentLevelTxnType: z.string(),
            aptcAmount: z.string().nullable(),
            enrollmentBenefitEffectiveStartDateUI: z.string().min(10, {
                message: 'error.member.enrollment_list.premiumhistory.enrollee.pleaseEnter.benefitStartDate',
            }),
            enrollmentBenefitEffectiveEndDateUI: z.string(),
            enrollmentLastPremPaidThroughDateUI: z.string(),
            enrolleeDataDtoList: z.array(
                z.object({
                    firstName: z.string(),
                    middleName: z.string().optional(),
                    lastName: z.string(),
                    genderLookupLabel: z.string(),
                    birthDate: z.string().optional(),
                    txnReason: z.string(),
                    txnType: z.union([z.string(), z.boolean()]),
                    enrolleeEffectiveStartDateUI: z.string(),
                    taxIdentificationNumber: z.string().nullable(),
                    enrolleeEffectiveEndDateUI: z.string(),
                }),
            ),
            addOrChangeComment: z.string().min(1, {
                message: 'error.member.enrollment_list.premiumhistory.enrollee.pleaseEnter',
            }),
            addOrChangeSendIn834: z.boolean(),
            sendTermNoticeVM: z.boolean().optional(),
            isTermReasonNonPayment: z.boolean(),
            endDateUnchanged: z.boolean(),
        })
        .superRefine((data, customError) => DateValidations(data, customError, isEdit))
        .superRefine((data, customError) => endDateValidation(data, customError));

const endDateValidation = (data, customError) => {
    let txnType = data.enrollmentLevelTxnType;
    if (txnType == TXN_TYPES.Term) {
        if (data.enrollmentBenefitEffectiveEndDateUI.substring(NUMBER.ZERO, NUMBER.FIVE) === LAST_DAY_OF_YEAR) {
            customError.addIssue({
                code: 'wrongDate',
                message: 'error.member.enrollment_list.termEnrollment.endDateError',
                path: ['enrollmentLevelTxnType'],
            });
        }
    }
};

const DateValidations = (data, customError, isEdit) => {
    if (isEdit && data.enrollmentLastPremPaidThroughDateU != '') {
        var lastPremDate = new Date(data.enrollmentLastPremPaidThroughDateUI);
        const startDate = new Date(data.enrollmentBenefitEffectiveStartDateUI);
        const endDate = new Date(data.enrollmentBenefitEffectiveEndDateUI);
        if (lastPremDate < startDate || lastPremDate > endDate) {
            customError.addIssue({
                code: 'wrongDate',
                message: 'error.member.enrollment_list.termEnrollee.coveragePeriod',
                path: ['enrollmentLastPremPaidThroughDateUI'],
            });
        }
    }
};
